// src/utils/api_formularios.js
import { api } from "@/utils/api_backend";

// ================================================================
// HISTORIAL — CONSUMO MATERIA PRIMA
// ================================================================

/**
 * Lista de consumos con filtros opcionales.
 * @param {{ search?: string, fecha_inicio?: string, fecha_fin?: string }} params
 */
export const getHistorialConsumoMP = (params = {}) =>
  api.get("historial/consumo-materia-prima/", { params }).then(r => r.data);

/**
 * Detalle completo de un consumo (incluye TPUs anidados).
 * @param {number} id
 */
export const getDetalleConsumoMP = (id) =>
  api.get(`historial/consumo-materia-prima/${id}/`).then(r => r.data);


// ================================================================
// HISTORIAL — SCRAP ALMACÉN Y LASER
// ================================================================

/**
 * Lista de registros de scrap con filtros opcionales.
 * @param {{ search?: string, fecha_inicio?: string, fecha_fin?: string }} params
 */
export const getHistorialScrapAlmacen = (params = {}) =>
  api.get("historial/scrap-almacen-laser/", { params }).then(r => r.data);

/**
 * Detalle completo de un registro de scrap.
 * @param {number} id
 */
export const getDetalleScrapAlmacen = (id) =>
  api.get(`historial/scrap-almacen-laser/${id}/`).then(r => r.data);


// ================================================================
// HISTORIAL — VENA Y SCRAP
// ================================================================

/**
 * Lista de registros de vena y scrap con filtros opcionales.
 * @param {{ search?: string, fecha_inicio?: string, fecha_fin?: string }} params
 */
export const getHistorialVenaScrap = (params = {}) =>
  api.get("historial/vena-scrap/", { params }).then(r => r.data);

/**
 * Detalle completo de un registro de vena y scrap.
 * @param {number} id
 */
export const getDetalleVenaScrap = (id) =>
  api.get(`historial/vena-scrap/${id}/`).then(r => r.data);